import { AuthContract } from './contracts/AuthContract.js';

export class AuthService extends AuthContract {

    constructor(options = {}) {
        super();

        const {
            httpClient,
            loginPath = '/auth/login',
            logoutPath = '/auth/logout',
            refreshPath = '/auth/refresh',
            userPath = '/auth/user',
        } = options;

        if (!httpClient) throw new Error('AuthService: "httpClient" is required.');

        this.http = httpClient;
        this.loginPath = String(loginPath || '/auth/login');
        this.logoutPath = String(logoutPath || '/auth/logout');
        this.refreshPath = String(refreshPath || '/auth/refresh');
        this.userPath = String(userPath || '/auth/user');
    }

    async login(credentials) {
        const response = await this.http.post(this.loginPath, credentials || {}, {
            contentType: 'json',
            responseType: 'json',
            auth: { type: 'cookie' },
            skipAuthRefresh: true,
        });
        return response?.payload ?? null;
    }

    async logout() {
        const response = await this.http.post(this.logoutPath, null, {
            contentType: 'json',
            responseType: 'json',
            auth: { type: 'cookie' },
            skipAuthRefresh: true,
        });
        return response?.payload ?? null;
    }

    async refresh(options = {}) {
        const authMethod = String(options.authMethod || 'cookie').toLowerCase();
        const payload = authMethod === 'bearer'
            ? { refreshToken: options.refreshToken || null }
            : null;
        const auth = authMethod === 'bearer'
            ? (options.accessToken ? { type: 'bearer', token: options.accessToken } : null)
            : { type: 'cookie' };

        const response = await this.http.post(this.refreshPath, payload, {
            contentType: 'json',
            responseType: 'json',
            auth,
            skipAuthRefresh: true,
        });
        return response?.payload ?? null;
    }

    async getUser(options = {}) {
        const authMethod = String(options.authMethod || 'cookie').toLowerCase();
        const auth = authMethod === 'bearer'
            ? { type: 'bearer', token: options.accessToken || '' }
            : { type: 'cookie' };

        const response = await this.http.get(this.userPath, null, {
            responseType: 'json',
            auth,
            skipAuthRefresh: true,
        });
        return response?.payload ?? null;
    }

}
